import {
    find,
    pipe,
    filter,
    sort,
    ascend,
    propEq,
    hasIn,
    propOr,
    prop,
    addIndex,
    map
} from './ramda';

const getMetadata = (task) => {
    return task.linkedResources[0].displayName.split('|');
}
export const getAmount = (task) => {
    let metadata = getMetadata(task);
    return Number(metadata[1].trim());
};

export const getType = (task) => {
    let metadata = getMetadata(task);
    return metadata[0].trim();
};

export const getPriorityState = (task) => {
    return task.importance === 'high';
};

export const getIgnoreState = (task) => {
    let metadata = getMetadata(task);
    let ignore = false
    // data consistency issue during dev
    if(metadata[2]) {
        let ignoreValue = metadata[2].split(':')[1].trim();
        ignore = ignoreValue === 'true';
    }
    return ignore;
}

export const getTotalPayments = (task) => {
    return task.payments.reduce((agg, payment) => {
        return agg += Number(payment.amount);
    }, 0);
};

export const getRealAmount = (task) => {
    return task.payments && task.payments.length ? getTotalPayments(task) : Number(task.amount);
};

export const getPaymentIDs = pipe(
    filter(hasIn('id')),
    map(prop('id'))
);

export const getParentEntry = (id) => find(propEq('id', id));

export const createEntry = (task, entry) => {
    let dueDate = task.dueDateTime ? task.dueDateTime.dateTime + (task.dueDateTime.timeZone === 'UTC' ? 'Z' : '') : null;
    let reminderDate = task.reminderDateTime ? task.reminderDateTime.dateTime + (task.reminderDateTime.timeZone === 'UTC' ? 'Z' : '') : null;
    return {
        ...entry,
        amount : Number(entry.amount),
        id : task.id,
        title : task.title,
        dueDate,
        reminderDate,
        isReminderOn : task.isReminderOn,
        complete : task.status === 'completed',
        priority  : getPriorityState(task),
        payments : [
            ...entry.payments
        ]
    }; 
};

export const modifyEntries = (modFunction) => {
    return pipe(
        sort(ascend(prop('order'))),
        modFunction,
        addIndex(map)((entry, index) => {
            return {
                ...entry,
                order : index
            };
        })
    );
};

export const isComplete = (id, entries) => pipe(find(propEq('id', id)), propOr(false, 'complete'))(entries);
